import React from "react";
import "./prediction.css";
import onClickOutside from "react-onclickoutside";
import SearchBlogCard from "../search-cards/SearchBlogCard";
import API_ENDPOINT from "../wm.api.service";

// image
import PeopleSearch from "../Components/People_Search/People_Search";

function PredictionBox({ hidden, close, searchedData,searchQuery, className,style }) {
  PredictionBox.handleClickOutside = () => close();
  return (
    <React.Fragment>
      {searchedData ? <div className={`predictionWrapper absolute w-full shadow overflow-x-hidden overflow-y-auto ${className} ${hidden ? 'hidden' : ''}`} style={{...style}}>
        <div className="searchresults">
          {/* Text Prediction */}
          {searchedData.questions?.data.length > 0 ? <div className="container-fluid py-3 border-b border-solid border-gray-300">
            <div className="row">
              <div className="col-md-12">
                {searchedData.questions?.data.slice(0,6).map((questionData, idx) => {
                  return <a key={idx} href={`https://wisemonkeys.info/questions/${questionData.slug}`} className="predict__text color-black block px-2 py-1 rounded manpro">
                    {questionData.question_title}
                  </a>
                })}
              </div>
            </div>
          </div> : ''}
          {/* People */}
          {searchedData.people?.data.length > 0 ? <div className="container-fluid py-3 border-b border-solid border-gray-300">
            <div className="row">
              <div className="col-md-12">
                {searchedData.people?.data.slice(0,6).map((peopleData, idx) => {
                  return <PeopleSearch key={idx} className="pb-2" peopleData={peopleData} onClick={() => close()}/>
                })}
              </div>
            </div>
          </div> : ""}
          {/* blogs card */}
          {searchedData.blog?.data.length > 0 ? <div className="container-fluid py-3 border-b border-solid border-gray-300">
            <div className="row">
              <div className="col-md-12">
                <span className="block manpro text-xl font-semibold mb-2">Blogs</span>
              </div>
              {searchedData.blog?.data.slice(0,6).map((blogData, idx) => {
                return <div key={idx} className="col-md-6 mb-2">
                  <SearchBlogCard blogData={blogData} />
                </div>
              })}
            </div>
          </div> : ''}
          {/* Show More */}
          <div className="container-fluid mt-3 mb-3">
            <div className="row">
              <div className="col-md-12">
                <div className="search_more text-center p-1" onClick={() => close()}>
                  <a href={`${API_ENDPOINT.redirectURL}/s/search?search_query=${searchQuery}`} className="bg-gray-300 rounded-md px-12 py-2 color-black manpro text-sm">See More</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> : ""}
    </React.Fragment>
  );
}
const clickOutsideConfig = {
  handleClickOutside: () => PredictionBox.handleClickOutside
};

export default onClickOutside(PredictionBox, clickOutsideConfig);
